import { useEffect } from 'react';
import ScreenService from '../services/screen-service';
import useScreenSmall from './use-screen-small';
import { HTML_TAG_NAME_MAIN } from '../constants/system/html-tag-names';

const useScroll: Function = (onScroll: ReactEventListener, deps: DepsItem[]): void => {
  const isSmallScreen: boolean = useScreenSmall();

  const onScrollEventListener: ReactEventListener = ScreenService.withDelay((
    event: React.UIEvent<HTMLDivElement>,
  ): void => {
    if (onScroll) {
      onScroll(event);
    }
  });

  useEffect((): ReactUseEffectCleanUp => {
    const mainElements: HTMLCollectionOf<HTMLElement> = ScreenService.getElementsByTagName(HTML_TAG_NAME_MAIN);
    const mainElement: HTMLElement = mainElements[0];

    if (mainElement && isSmallScreen) {
      mainElement.addEventListener('scroll', onScrollEventListener);
    }

    return (): void => {
      if (mainElement && isSmallScreen) {
        mainElement.removeEventListener('scroll', onScrollEventListener);
      }
    };
  }, [isSmallScreen, [...(deps || [])]]);
};

export default useScroll;
